export default __webpack_public_path__ + "static/media/seongdong-gu.5659884a.jpg";